/* eslint-disable sort-keys-fix/sort-keys-fix */
// NOTE: name should be lowercase as lowercase serializer is used.
export const MATH_LEADERS_ROUTE = {
  name: 'mathleaders',
  route(): string[] {
    return ['/' + this.name];
  },
  HANDBOOK: {
    name: 'handbook',
    route(): string[] {
      return [...MATH_LEADERS_ROUTE.route(), this.name];
    },
    COMMON_BOOK: {
      name: 'commonunderstandingofassessment',
      route(): string[] {
        return [...MATH_LEADERS_ROUTE.HANDBOOK.route(), this.name];
      }
    },
    FOUR_CHALLENGES_BOOK: {
      name: 'fourchallengesmathleadersface',
      route(): string[] {
        return [...MATH_LEADERS_ROUTE.HANDBOOK.route(), this.name];
      }
    },
    RETURN_TO_LEARN_BOOK: {
      name: 'returntolearn',
      route(): string[] {
        return [...MATH_LEADERS_ROUTE.HANDBOOK.route(), this.name];
      }
    },
    UNDERSTANDING_ROLE_BOOK: {
      name: 'understandingroleofmathleader',
      route(): string[] {
        return [...MATH_LEADERS_ROUTE.HANDBOOK.route(), this.name];
      }
    }
  },
  HOME: {
    name: 'home',
    route(): string[] {
      return [...MATH_LEADERS_ROUTE.route(), this.name];
    }
  },
  PODCAST: {
    name: 'podcast/:contentid',
    route(contentId: string): string[] {
      return [...MATH_LEADERS_ROUTE.route(), 'podcast', contentId];
    }
  },
  PODCASTS: {
    name: 'podcasts',
    route(): string[] {
      return [...MATH_LEADERS_ROUTE.route(), this.name];
    }
  },
  READING_LIST: {
    name: 'readinglist',
    route(): string[] {
      return [...MATH_LEADERS_ROUTE.route(), this.name];
    }
  },
  ROUNDTABLES: {
    name: 'roundtables',
    route(): string[] {
      return [...MATH_LEADERS_ROUTE.route(), this.name];
    }
  },
  SPEAKERS: {
    name: 'speakers',
    route(): string[] {
      return [...MATH_LEADERS_ROUTE.route(), this.name];
    }
  },
  VIDEO: {
    name: 'video/:videoid',
    route(videoId: string): string[] {
      return [...MATH_LEADERS_ROUTE.route(), 'video', videoId];
    }
  },
  VIDEOS: {
    name: 'videos',
    route(): string[] {
      return [...MATH_LEADERS_ROUTE.route(), this.name];
    }
  },
  WEBINAR: {
    name: 'webinar/:contentid',
    route(contentId: string): string[] {
      return [...MATH_LEADERS_ROUTE.route(), 'webinar', contentId];
    }
  },
  WELCOME: {
    name: 'welcome',
    route(): string[] {
      return [...MATH_LEADERS_ROUTE.route(), this.name];
    }
  },
  WORKSHOPS: {
    name: 'workshops',
    route(): string[] {
      return [...MATH_LEADERS_ROUTE.route(), this.name];
    }
  }
};
